import { Routes, Route, useLocation } from 'react-router-dom';
import React, { useState, useCallback } from "react";
import { useAuth } from '../context/AuthContext';
import { Box, Typography } from '@mui/material';
import Layout from '../components/Layout';
import ProjectsPage from '../components/ProjectsPage';
import PersonalProjectsPage from '../components/PersonalProjectsPage';
import HomePage from '../components/HomePage';
import Login from '../components/Login';
import PersonaBlogsList from '../components/blogs/PersonaBlogsList';
import BlogPostPage from '../components/blogs/BlogPostPage';
import AllBlogsPage from '../components/blogs/AllBlogsPage';
import ToolProjectsPage from '../components/ToolProjects';
import PublicBlogPostPage from '../components/blogs/PublicBlogPostPage';
import PublicAllBlogsPage from '../components/blogs/PublicAllBlogsPage';
import PublicPersonaBlogsList from '../components/blogs/PublicPersonaBlogsList';

const AppRoutes = () => {
  console.log("🔹 AppRoutes rendering...");
  const { user } = useAuth();
  const location = useLocation();
  const [error, setError] = useState("");
  const [showLoginModal, setShowLoginModal] = useState(false);

  // ✅ Memoized function to prevent re-renders
  const handleInteraction = useCallback(() => {
    console.log("🔹 handleInteraction called");
    if (!user) {
      setShowLoginModal(true);
    }
  }, [user]);

  const handleLoginClick = () => {
    console.log("🔹 handleLoginClick called");
    setShowLoginModal(true);
  };

  console.log("🔹 Current path:", location.pathname);

  return (
    <>
      <Routes>
        {/* HomePage route (root path) */}
        <Route
          path="/"
          element={
            <Layout user={user} onLoginClick={handleLoginClick}>
              <HomePage 
                user={user} 
                setError={setError} 
                error={error} 
                onInteraction={handleInteraction}
              />
            </Layout>
          }
        />
        
        {/* Projects route */}
        <Route
          path="/projects"
          element={
            <Layout user={user} onLoginClick={handleLoginClick}>
              <ProjectsPage 
                user={user} 
                onInteraction={handleInteraction} 
              />
            </Layout>
          }
        />
        
        {/* Personal Projects route */}
        <Route
          path="/personal-projects"
          element={
            <Layout user={user} onLoginClick={handleLoginClick}>
              <PersonalProjectsPage 
                user={user} 
                onInteraction={handleInteraction} 
              />
            </Layout>
          }
        />
        <Route
        path="/tools"
         element={
            <Layout user={user} onLoginClick={handleLoginClick}>
           <ToolProjectsPage 
           user={user} 
           setError={setError} 
           error={error} 
          onInteraction={handleInteraction} 
           />
          </Layout>
        }
        />
        <Route
        path="/blogs"
        element={
       <Layout user={user} onLoginClick={handleLoginClick}>
       <AllBlogsPage 
        user={user} 
        onInteraction={handleInteraction} 
        />
        </Layout>
       }
        />
      <Route
      path="/persona/:personaId/blogs"
      element={
        <Layout user={user} onLoginClick={handleLoginClick}>
      <PersonaBlogsList 
        user={user} 
        onInteraction={handleInteraction} 
      />
    </Layout>
      }
    />
      <Route
    path="/blog/:blogId"
    element={
    <Layout user={user} onLoginClick={handleLoginClick}>
      <BlogPostPage 
        user={user} 
        onInteraction={handleInteraction} 
      />
    </Layout>
    }
    />
         {/* Public blog routes (no authentication required) */}
        <Route
          path="/public/blogs"
          element={
            <Layout user={user} onLoginClick={handleLoginClick}>
              <PublicAllBlogsPage />
            </Layout>
          }
        />
        
        <Route
          path="/public/persona/:personaId/blogs"
          element={
            <Layout user={user} onLoginClick={handleLoginClick}>
              <PublicPersonaBlogsList />
            </Layout>
          }
        />

        <Route
          path="/public/blog/:blogId"
          element={
            <Layout user={user} onLoginClick={handleLoginClick}>
              <PublicBlogPostPage />
            </Layout>
          }
        />
        {/* Catch-all route */}
        <Route 
          path="*" 
          element={
            <Layout user={user} onLoginClick={handleLoginClick}>
              <Box sx={{ p: 3 }}>
                <Typography variant="h4">Page Not Found</Typography>
              </Box>
            </Layout>
          }
        />
      </Routes>

      {/* ✅ Show Login Modal Only When Needed */}
      {showLoginModal && (
        <Login 
          isModal={true} 
          onSuccess={() => {
            console.log("✅ Login Successful - Closing Modal");
            setShowLoginModal(false);
          }} 
          onClose={() => {
            console.log("✅ Modal Closed");
            setShowLoginModal(false);
          }} 
        />
      )}
    </>
  );
};

export default AppRoutes;